"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stepper = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  marginTop: theme.spacing(6),
  marginBottom: theme.spacing(9)
}));
const StyledStep = (0, _mui.styled)(_mui.Step)(({
  theme
}) => ({
  textAlign: 'center'
}));
const Stepper = props => {
  const {
    steps,
    visibleLables,
    canChangeStep
  } = props;
  const {
    stepperData
  } = (0, _contexts.useStepperData)();
  const {
    activeStep,
    setActiveStep,
    setManualChange
  } = stepperData;
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const handleChangeStep = stepNumber => {
    if (canChangeStep) {
      setManualChange(true);
      setActiveStep(stepNumber);
    }
  };
  const stepperWidth = steps.length > 1 ? `${steps.length * 130 - 75}px` : 'auto';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RootContainer, {
    children: steps.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Stepper, {
      ...getTestIdProps('stepper'),
      activeStep: activeStep,
      style: {
        width: stepperWidth
      },
      children: steps.map((label, index) => /*#__PURE__*/(0, _react.createElement)(StyledStep, {
        ...getTestIdProps('stepper-step'),
        key: label,
        onClick: () => handleChangeStep(index)
      }, /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.StepLabel, {
        ...getTestIdProps('stepper-step-label'),
        children: visibleLables ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...getTestIdProps('stepper-step-label-text'),
          children: "label"
        }) : null
      })))
    })
  });
};
exports.Stepper = Stepper;